module.exports = __webpack_public_path__ + "static/media/paperclip.2ed41df3.svg";